import { useAtomValue } from "jotai";
import { Navigate } from "react-router-dom";

import { FALLBACK_HOME_PATH, getDefaultHomePath } from "@/routes/menuConfig";
import { menusAtom } from "@/store/auth";

/** 根路径重定向：跳转到用户首个可访问页面 */
export const HomeRedirect = () => {
  const menus = useAtomValue(menusAtom);
  const target = menus.length > 0 ? getDefaultHomePath(menus) : FALLBACK_HOME_PATH;
  return <Navigate to={target} replace />;
};
